// tslint:disable:max-line-length

import React from 'react';

export const ActionDownload = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M13,8V7c0-2.8-2.2-5-5-5C5.5,2,3.5,3.8,3.1,6.1C1.3,6.5,0,8.1,0,10c0,2.2,1.8,4,4,4h3.7L4,10.3h3v-3h2v3h3L8.3,14H13 c1.7,0,3-1.3,3-3S14.7,8,13,8z" />
    </svg>
  );
};
